import moment from 'moment'
import { stringify } from 'query-string'
import fileDownload from 'js-file-download'

import { createXlsxData } from '../../../utils'
import { fetchWithAuthorization } from '../../../../../../../../lib/api'
import {
  toastNotifyDownloadFuzzyAnswerLogsError,
  toastNotifyDownloadFuzzyAnswerLogsInfo,
  toastNotifyDownloadFuzzyAnswerLogsSuccess
} from './toasts'
import { getApiUrl } from '../../../../../../../../apiService'

export async function downloadFuzzyQuestionAnswerLogs(
  botId: string,
  fromTimestamp: number,
  toTimestamp: number,
  setIsFileDownloading: (value: boolean) => void
): Promise<void> {
  setIsFileDownloading(true)
  const query = stringify({ fromTimestamp, toTimestamp })
  try {
    const logs = await fetchWithAuthorization(
      getApiUrl(`/bots/${botId}/export/fuzzyQuestionAnswerLog?${query}`),
      { method: 'GET', checkOk: true }
    )

    if (!logs?.length) {
      setIsFileDownloading(false)
      toastNotifyDownloadFuzzyAnswerLogsInfo()
      return
    }

    const data = createXlsxData('Fuzzy question answer logs', logs)
    fileDownload(data, `${botId}-${moment().format('YYYY-MM-DD')}.xlsx`)

    setIsFileDownloading(false)
    toastNotifyDownloadFuzzyAnswerLogsSuccess(logs.length)
  } catch (error) {
    console.error((error as Error)?.message)
    setIsFileDownloading(false)
    toastNotifyDownloadFuzzyAnswerLogsError()
  }
}
